import { useFetch } from "lib/useFetch";

export const IndustryGroupsDataProvider = () => {
  const URL = "/research/japi/coverage/fetchIndustryGroups";
  let [response, isLoading, error] = useFetch(URL, null, "GET");
  return [response, isLoading, error];
};
